module.exports = __webpack_public_path__ + "img/gentlemen-club-carousel-35.5c81e78b.png";